// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__jKXMe","selects":"Documents_selects__qYoa3"};